const ALLOWED_COOKIES = ['_kawlt', '_kpawbat_e'];

export function getApiProxyCookieString(cookieString?: string): string | undefined {
  if (!cookieString) {
    return '';
  }
  const allowedCookies = ALLOWED_COOKIES.map(cookie => {
    return cookieString.split('; ').find(c => {
      const key = c.split('=')[0];
      return key === cookie;
    });
  }).filter(Boolean);

  return allowedCookies.length > 0 ? allowedCookies.join('; ') : '';
}
